module.exports = __webpack_public_path__ + "e23a0cf4cce8f0240c6d49537b9ea86e.MP3";